import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Formatter from "../../Data/Domain/Formatter";
import { message } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import { getOwnersByProject } from "../Application/Owners.bussines";
import {
  getsetOwnersByProjectSelector,
  getOwnersByProjectCountSelector,
} from "../Infrastructure/Owners.reducer";
import "./Owners.css";
import Storage from "../../Data/Domain/Storage";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ProjectOutlinedIcon,
  // EnvironmentOutlinedIcon,
  Title,
  CustomCard,
} from "../../Utils/UI/Text";
import PropertiesModal from "../../Properties/UI/PropertiesModal";

const Owners = ({ setPage }) => {
  const ownersByProject = useSelector(getsetOwnersByProjectSelector);
  const ownersByCount = useSelector(getOwnersByProjectCountSelector);
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });
  const navigate = useNavigate();
  const location = useLocation();

  const goToProject = (projectId) => {
    navigate(`/projects/${projectId}`, {
      state: {
        from: location.pathname,
      },
    });
  };

  // const showPropertiesModal = (projectId) => {
  //   setSelectedProjectId(projectId);
  //   setPropertiesModalVisible(true);
  // };

  const hidePropertiesModal = () => {
    setPropertiesModalVisible(false);
    setSelectedProjectId(null);
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "projectNameForSearcher",
      key: "project_name",
    },
    {
      title: "Acciones",
      key: "",
      render: (_, record) => {
        return (
          <div
            style={{ display: "flex", gap: "8px", justifyContent: "center" }}
          >
            <ProjectOutlinedIcon
              onClick={() => goToProject(record.id)}
              TooltipProjectOutlined="Detalle del Proyecto"
            />
            {/* <EnvironmentOutlinedIcon
              onClick={() => showPropertiesModal(record.id)}
              TooltipEnvironmentOutlined="Ver Predios"
            /> */}
          </div>
        );
      },
    },
  ];
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState("false");
  const [propertiesModalVisible, setPropertiesModalVisible] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const fetchData = async (params = {}) => {
    try {
      const id = params.id || new Storage("id").getItem();

      await getOwnersByProject(id);
      const filtros = params.filter ? JSON.stringify(params.filter) : [""];
      setFilters(filtros);
      if (Object.entries(params).length > 0) message.success("Filtrado");
      setLoading(false);
      message.success("Filtrado");
    } catch (error) {
      message.error("error");
    }
  };

  useEffect(() => {
    getOwnersByProject();
    fetchData({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequest = (newPagination = {}, filters = {}, sorter = {}) => {
    const { current: page = 1, pageSize: limit = 5 } = newPagination;
    const { field: sortField, order: sortOrder } = sorter;
    const clean = Formatter.cleanParamsFromTableToAPI({
      ...filters,
      limit,
      sortField,
      sortOrder,
      page: page - 1,
      dates: [],
    });
    setValues({
      ...values,
      limit,
      page: page - 1,
    });
    fetchData(clean);
  };

  return (
    <>
      <Title children={"Mis Proyectos"} />

      <CustomCard>
        <InterfaceTable
          rowKey="id"
          data={ownersByProject}
          columns={columns}
          onChange={handleRequest}
          pagination={{
            pageSize: values.limit,
            total: ownersByCount,
            onChange: (current) => {
              //getOwnersByProject({ page: current - 1, values.limit });
            },
          }}
        />
      </CustomCard>

      <PropertiesModal
        projectId={selectedProjectId}
        visible={propertiesModalVisible}
        onCancel={hidePropertiesModal}
      />
    </>
  );
};

export default Owners;
